import { request } from '@/utils/request'
import { toDictionary } from '@/utils/array'
import { translate } from '@/utils/validation'

function createExecutive(w) {
    return {
        colloquialName: w.executiveName,
        position: w.executiveTitle,
        currentCompany: {
            name: w.company,
            symbol: w.symbol,
        },
    }
}

function unpack(content) {
    const executives = toDictionary(content.executives, e => e.id)
    const users = toDictionary(content.users, u => u.id)
    const packages = toDictionary(content.packages, p => p.key)

    return content.work
        .filter(w => w.reportStatus !== 'Cancelled')
        .map(w => ({
            ...w,
            packageDetails: packages[w.package] ?? { key: w.package, name: w.package },
            executive: executives[w.executiveId] ?? createExecutive(w),
            user: users[w.userId],
        }))
}

export const FIELDS = {
    package: 'Package',
    price: 'Price',
}

export const CustomWorkService = {
    async list() {
        return unpack(await request.get('/api/custom-work-items'))
    },
    async create(order) {
        const response = await request.post('/api/custom-work-orders', order)

        if (response.ok) {
            response.content = unpack(response.content)
        } else if (response.status === 422) {
            translate(response.content, FIELDS)
        }

        return response
    },
}
